import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";

export const getNotificationsPage = page => {
  return dispatch => {
    //dispatch({ type: "GET_NOTIFICATIONS_LOADING" });
    api
      .notificationsGetPage(page)
      .then(resp => {
        dispatch({ type: "GET_NOTIFICATIONS_LOADING_DONE" });
        dispatch(operationSucceeded(resp.data, page));
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_NOTIFICATIONS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetNotificationsErrorAlertTitle",
          "Virhe ilmoitusten haussa",
          e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const getNotificationsAfter = (days, page) => {
  return dispatch => {
    //dispatch({ type: "GET_NOTIFICATIONS_LOADING" });
    api
      .notificationsGetAfter(days, page)
      .then(resp => {
        dispatch({ type: "GET_NOTIFICATIONS_LOADING_DONE" });
        dispatch(operationSucceeded(resp.data, page));
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_NOTIFICATIONS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetNotificationsErrorAlertTitle",
          "Virhe ilmoitusten haussa",
          e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const getNotificationsBefore = (days, page) => {
  return dispatch => {
    //dispatch({ type: "GET_NOTIFICATIONS_LOADING" });
    api
      .notificationsGetBefore(days, page)
      .then(resp => {
        dispatch({ type: "GET_NOTIFICATIONS_LOADING_DONE" });
        dispatch(operationSucceeded(resp.data, page));
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_NOTIFICATIONS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetNotificationsErrorAlertTitle",
          "Virhe ilmoitusten haussa",
          e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const getNotificationsBetween = (afterDays, beforeDays, page) => {
  return dispatch => {
    //dispatch({ type: "GET_NOTIFICATIONS_LOADING" });
    api
      .notificationsGetBetween(afterDays, beforeDays, page)
      .then(resp => {
        dispatch({ type: "GET_NOTIFICATIONS_LOADING_DONE" });
        dispatch(operationSucceeded(resp.data, page));
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_NOTIFICATIONS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetNotificationsErrorAlertTitle",
          "Virhe ilmoitusten haussa",
          e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = (data, page) => {
  if (page === 0) {
    return {
      type: "GET_NOTIFICATIONS_FIRSTPAGE_SUCCEEDED",
      payload: data,
    };
  }
  if (data.length === 0) {
    return {
      type: "GET_NOTIFICATIONS_ALL_LOADED",
    };
  }
  return {
    type: "GET_NOTIFICATIONS_PAGE_SUCCEEDED",
    payload: data,
  };
};

const operationFail = () => ({
  type: "GET_NOTIFICATIONS_FAIL"
});
